// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xkdL","newExpiryDate":"styles_newExpiryDate__2ryzX","footer":"styles_footer__2Ke4a"};